import React from 'react'
import { connect } from 'react-redux'
import { routes } from '../../constants/routes'
import { Link } from 'react-router-dom'
import { ReactComponent as EdgeOne } from '../../assets/svgs/hp-edges-01.svg'
import { ReactComponent as EdgeTwo } from '../../assets/svgs/hp-edges-02.svg'
import { ReactComponent as EdgeThree } from '../../assets/svgs/hp-edges-03.svg'
import { ReactComponent as EdgeFour } from '../../assets/svgs/hp-edges-04.svg'
import { ReactComponent as EdgeFive } from '../../assets/svgs/hp-edges-05.svg'

const mapStateToProps = (state) => {
    const { nav, ui } = state
    return {
        navState: nav,
        uiWidth: ui.width,
        uiHeight: ui.height
    }
}

const HomeMobile = ({ dispatch, navState, onActivateClip }) => {
    return (
        <div id="home-mobile">
            <div className="title home-mobile-wrapper">
                <h1>
                    <span>Way Outta</span><span>No Way</span>
                </h1>
                <p>
                    <Link target="_blank" className="home-cta" to={routes.whyWeAreHere.path}>
                        <span>Why We're Here</span>
                    </Link>
                </p>
                <p>
                    <Link className="home-cta" to={routes.community.path}>
                        <span>Stay in Touch</span>
                    </Link>
                </p>
            </div>
            <div className="murphys home-mobile-wrapper teal-bg">
                <div className="section-edge">
                    <EdgeOne />
                </div>
                <div className="hp-title" onClick={() => onActivateClip('murphys', routes.murphysIndex.path, 'tales from', 'the east side')}>
                    Tales from<br />
                    the East Side
                </div>
                <div className="hp-description">
                    Get to know the friends and family of Clayville's east side. See how systemic racism shapes the experience of their everyday lives.
                </div>
                <button className="hp-section-link"
                    onClick={() => onActivateClip('murphys', routes.murphysIndex.path, 'tales from', 'the east side')}>
                        Explore
                </button>
                <img src="home-meet-the-murphys.png" alt="Meet the Murphys"/>
            </div>
            <div className="clayville home-mobile-wrapper orange-bg">
                <div className="section-edge">
                    <EdgeTwo />
                </div>
                <div className="hp-title" onClick={() => onActivateClip('clayville', routes.clayvilleIndex.path, 'explore', 'clayville')}>
                    Discover<br />
                    Clayville
                </div>
                <div className="hp-description">
                    Explore the city of Clayville. Visit key landmarks that structure the city's segregated resources and communities.
                </div>
                <img src="home-clayville.png" alt="Explore Clayville"/>
                <button className="hp-section-link"
                    onClick={() => onActivateClip('clayville', routes.clayvilleIndex.path, 'explore', 'clayville')}>
                        Explore
                </button>
            </div>
            <div className="spirit-stays-free home-mobile-wrapper yellow-bg">
                <div className="section-edge">
                    <EdgeThree />
                </div>
                <div className="hp-title" onClick={() => onActivateClip('spirit-stays-free', routes.spiritStaysFree.path, 'view', 'spirit stays free')}>
                    Spirit<br />
                    Stays Free
                </div>
                <div className="hp-description">
                    The Black artists and activists featured here inspire us.
                </div>
                <img src="home-site-guides.png" alt="Spirit Stays Free"/>
                <button className="hp-section-link"
                    onClick={() => onActivateClip('spirit-stays-free', routes.spiritStaysFree.path, 'view', 'spirit stays free')}>
                        Explore
                </button>
            </div>
            <div className="key-issues home-mobile-wrapper blue-bg">
                <div className="section-edge">
                    <EdgeFour />
                </div>
                <div className="hp-title" onClick={() => onActivateClip('key-issues', routes.keyIssuesIndex.path, 'Explore', 'Key Issues')}>
                    Explore<br />Key Issues
                </div>
                <div className="hp-description">
                Everyday policies and practices fuel and maintain systemic racism.
                </div>
                <img src="home-key-issues.png" alt="Key Issues"/>
                <button className="hp-section-link"
                    onClick={() => onActivateClip('key-issues', routes.keyIssuesIndex.path, 'Explore', 'Key Issues')}>
                        Explore
                </button>
            </div>
            <div className="systemic-racism home-mobile-wrapper magenta-bg">
                <div className="section-edge">
                    <EdgeFive />
                </div>
                <div className="hp-title" onClick={() => onActivateClip('systemic-racism', routes.systemicRacismExplained.path, 'Systemic Racism', 'Explained')}>
                    Systemic<br />Racism<br />Explained
                </div>
                <div className="hp-description">
                Why a systems approach is essential to understand racism.
                </div>
                <img src="home-systemic-racism.png" alt="Systemic Racism Explained"/>
                <button className="hp-section-link"
                    onClick={() => onActivateClip('systemic-racism', routes.systemicRacismExplained.path, 'Systemic Racism', 'Explained')}>
                        Explore
                </button>
            </div>
        </div>
    )
}

export default connect(mapStateToProps)(HomeMobile)
